<template>
  <div>
    <div class="container">
      <div v-if="isLoading" style="padding-top: 100px;" class="container has-text-centered opaque">
        <i class="fa fa-refresh fa-spin fa-4x"></i>
        <p>Loading...</p>
      </div>
      <div v-if="!isLoading" class="container crud-page-header">
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul>
            <li>
              <router-link to="/requests">Requests</router-link>
            </li>
            <li class="is-active">
              <router-link to="/associations">{{request.Association.Name}}</router-link>
            </li>
          </ul>
        </nav>
        <div class="field crud-buttons is-grouped is-pulled-right">
          <div class="control hide-mobile">
            <button class="button is-text" @click="cancel">Back</button>
          </div>
          <div class="control">
            <button @click="putRequest(request)" :class="{'is-loading': isSaving}" class="button is-link">Save</button>
          </div>
          <div class="control">
            <button class="button is-link hide-mobile" :class="{'is-loading': isGeneratingPdf}" @click="openEmailModal()">
              Email (PDF)
              <i style="padding-left: 10px;" class="fa fa-lg fa-envelope-open"></i>
            </button>
            <button class="button is-link hide-desktop" :class="{'is-loading': isGeneratingPdf}" @click="openEmailModal()">
              <i class="fa fa-lg fa-envelope-open"></i>
            </button>
          </div>
          <span>
            <!-- hidden anchor -->
            <a ref="pdf" :download="fileName" :href="pdflink"></a>
            <button class="button is-link hide-mobile" :class="{'is-loading': isGeneratingPdf}" @click="getPdf">
              Download (PDF)
              <i style="padding-left: 10px;" class="fa fa-lg fa-download"></i>
            </button>
            <button class="button is-link hide-desktop" :class="{'is-loading': isGeneratingPdf}" @click="getPdf">
              <i class="fa fa-lg fa-download"></i>
            </button>
          </span>
        </div>
        <div class="section hide-mobile">
          <h3 class="title is-5">Request Information</h3>
          <hr>
        </div>
      </div>
    </div>
    <div v-if="!isLoading" class="container crud-body">
      <section class="section">
        <div class="columns">
          <div class="column is-half">
            <div class="field">
              <label class="label is-small">Requester Name</label>
              <div class="control">
                <input class="input is-small" v-model="request.RequesterName" type="text" placeholder="Requester Name">
              </div>
            </div>
          </div>
          <div class="column is-half">
            <div class="field">
              <label class="label is-small">Requester Email</label>
              <div class="control">
                <input class="input is-small" v-model="request.RequesterEmail" type="text" placeholder="Requester Email">
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="section">
        <div class="columns is-desktop">
          <div class="column">
            <Accord24 :accord24="accord24" :requestViewer="true"></Accord24>
            <Accord24 style="display: none;" ref="accord" :accord24="accord24" :readonly="true"></Accord24>
          </div>
          <div class="column">
            <div v-if="request.Association.Attachments && request.Association.Attachments.length > 0" class="content is-small" style="margin-top: 20px; max-width: 330px; word-break: break-all;">
              <h4>Additional Declarations</h4>
              <ul class="table"
                style="margin-top: 10px; font-size: 13px; margin-bottom: 0px;">
                <li v-for="attachment in request.Association.Attachments">
                  <a :href="attachment.downloadURL" target="_blank">{{attachment.fileName}}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div v-if="!isLoading" class="modal" :class="{'is-active': showEmailModal}">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Email Certificate</p>
          <button @click="closeEmailModal()" class="delete"></button>
        </header>
        <div v-if="!emailSuccess">
          <section class="modal-card-body">
            <div class="content">
              <div class="field">
                <label class="label">To</label>
                <div class="control">
                  <input class="input" type="text" v-model="emailData.to" placeholder="Enter a comma separated list of email address">
                  <p v-if="emailInvalidTo" class="help is-danger">
                    Valid email address is required
                  </p>
                </div>
              </div>
              <div class="field">
                <label class="label">CC</label>
                <div class="control">
                  <input class="input" type="text" v-model="emailData.cc" placeholder="Enter a comma separated list of email address">
                  <p v-if="emailInvalidCc" class="help is-danger">
                    Valid email address is required
                  </p>
                  <p class="help">
                    <i class="fa fa-lg fa-paperclip"></i> {{getAttachmentName()}}</p>
                </div>
              </div>
              <div class="field">
                <label class="label">Message</label>
                <div class="control">
                  <textarea class="textarea" v-model="emailData.message" placeholder="Enter message"></textarea>
                </div>
              </div>
            </div>
          </section>
          <section v-if="emailError" class="modal-card-body">
            <hr> Error sending email! Please try again or download PDF and send externally.
            </br>
            </br>
          </section>
          <footer class="modal-card-foot">
            <a class="button is-success" :class="{'is-loading': isSendingEmail}" @click="sendEmailMessage(emailData)">Send</a>
            <a @click="closeEmailModal()" class="button">Cancel</a>
          </footer>
        </div>
        <div v-if="emailSuccess">
          <section class="modal-card-body">
            Thank you, your email has been sent.
            </br>
            </br>
          </section>
          <footer class="modal-card-foot">
            <a @click="closeEmailModal()" class="button">Close</a>
          </footer>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import tenant from '@/tenant'
  import Accord24 from '@/components/associations/Accord24'
  import accordUtil from '@/utilities/accord-util'
  import axios from 'axios'

  export default {
    name: 'RequestViewer',
    data: function () {
      return {
        isLoading: true,
        isSaving: false,
        isGeneratingPdf: false,
        showEmailModal: false,
        emailSuccess: false,
        emailError: false,
        emailInvalidTo: false,
        emailInvalidCc: false,
        isSendingEmail: false,
        emailData: {
          to: '',
          cc: '',
          message: null
        },
        request: {},
        fileName: '',
        pdflink: '',
        accord24: {}
      }
    },
    created: function () {
      tenant.initialize().then(() => {
        this.initialize(this.$route)
      })
    },
    methods: {
      initialize(route) {
        window.document.title = 'View Request'
        this.fetchRequest(route.params.id)
      },
      fetchRequest(Id) {
        tenant.ref('requests/' + Id).once('value').then((snapshot) => {
          this.request = snapshot.val()
          this.accord24 = this.request.Association.Accord24
          if (this.accord24.AdditionalRemarks) {
            this.accord24.AdditionalRemarks = this.accord24.AdditionalRemarks.replace(/<br>/gi, '\n')
          }
          this.isLoading = false
        })
      },
      putRequest(request) {
        let key = this.$route.params.id
        this.isSaving = true
        tenant.ref('requests/' + key).set(request).then(() => {
          this.isSaving = false
        })
      },
      getPdf() {
        this.isGeneratingPdf = true

        // go ahead and do a save
        let key = this.$route.params.id
        tenant.ref('requests/' + key).set(this.request)

        let accordForm = this.$refs['accord'].$el.innerHTML
        let rawHTML = this.getAccordDOM(accordForm)
        axios.post(process.env.API_BASE_URL + '/api/certificates/pdf', rawHTML, { responseType: 'arraybuffer' }).then((response) => {
          let blob = new Blob([response.data], { type: 'application/pdf' })
          this.isGeneratingPdf = false
          if (navigator.appVersion.toString().indexOf('.NET') > 0) {
            window.navigator.msSaveBlob(blob, 'InsuranceCertificate.pdf')
          } else {
            this.pdflink = window.URL.createObjectURL(blob)
            this.fileName = 'InsuranceCertificate.pdf'
            this.$nextTick(() => {
              this.$refs['pdf'].click()
            })
          }
        }).catch((error) => {
          this.isGeneratingPdf = false
          console.log(error)
        })
      },
      getAccordDOM(accordForm) {
        return accordUtil.getAccordDOM(accordForm)
      },
      getAttachmentName() {
        let name = this.request.Association.Name
        name = name.replace(/ /g, '')
        name = name.replace(/,/g, '')
        return name + '_COI.pdf'
      },
      openEmailModal() {
        if (!this.emailData.message) {
          this.emailData.message = 'Please see attached Certificate of Insurance for ' + this.request.Association.Name + '.'
          this.showEmailModal = true
        } else {
          this.showEmailModal = true
        }
      },
      closeEmailModal() {
        this.showEmailModal = false
        this.emailSuccess = false
        this.emailError = false
      },
      validateEmailForm(emailData) {
        let foundError = false
        let to = emailData.to
        if (!to || to.indexOf('@') < 1 || to.indexOf('.') < 2) {
          this.emailInvalidTo = true
          foundError = true
        } else {
          this.emailInvalidTo = false
        }

        let cc = emailData.cc
        if (cc && (cc.indexOf('@') < 1 || cc.indexOf('.') < 2)) {
          this.emailInvalidCc = true
          foundError = true
        } else {
          this.emailInvalidCc = false
        }

        if (foundError) {
          return false
        }

        return true
      },
      sendEmailMessage(emailData) {
        if (!this.validateEmailForm(emailData)) {
          return
        }
        let accordForm = this.$refs['accord'].$el.innerHTML
        emailData.rawHTML = this.getAccordDOM(accordForm)
        emailData.subject = 'Certificate of Insurance for ' + this.request.Association.Name
        emailData.attachmentName = this.getAttachmentName()
        if (emailData.message.indexOf('https://www.getcoi.com') < 0) {
          emailData.message += `



_____________________________

This certificate was provided by GetCOI. We help independent insurance brokers automate certificate of insurance requests.
https://www.getcoi.com
        `
        }

        this.isSendingEmail = true
        axios.post(process.env.API_BASE_URL + '/api/certificates/email-pdf', emailData).then((response) => {
          this.emailSuccess = true
          this.isSendingEmail = false
        }).catch((error) => {
          this.isSendingEmail = false
          this.emailError = true
          console.log(error)
        })
      },
      cancel() {
        this.$router.push('/requests')
      }
    },
    watch: {
      '$route'() {
        this.initialize(this.$route)
      },
      floatResearch: function () {
        this.researchScroll()
      }
    },
    components: {
      Accord24
    }
  }

</script>

<style scoped>
  .request-title {
    margin-bottom: 20px;
    font-size: 24px;
  }

  .breadcrumb {
    margin-bottom: 0px;
  }

  .section {
    padding-bottom: 0px;
  }
</style>


// WEBPACK FOOTER //
// src/components/request/RequestViewer.vue?f2a155b2